import React from "react";
import {
	AccountIcon,
	AdminIcon,
	AlarmIcon,
	ApplyIcon,
	InvestIcon, ManagementIcon,
	PluginIcon,
	PortfolioIcon, ReviewSettingIcon,
	RoundIcon,
	VcInfoIcon,
} from "~/assets/svg/SidebarMenuIcon";
import { Case, If } from "~/common/components/If";
import SquareInitialImg from "~/assets/img/logo-vc.png";
import { useTranslation } from "react-i18next";

const MainMenuIcon = ({ id }) => {
	return (
		<If condition={id}>
			<Case condition={"vcInfo"}>
				<VcInfoIcon />
			</Case>
			<Case condition={"portfolio"}>
				<PortfolioIcon />
			</Case>
			<Case condition={"invest"}>
				<InvestIcon />
			</Case>
			<Case condition={"round"}>
				<RoundIcon />
			</Case>
			<Case condition={"apply"}>
				<ApplyIcon />
			</Case>
			<Case condition={"account"}>
				<AccountIcon />
			</Case>
			<Case condition={"alarm"}>
				<AlarmIcon />
			</Case>
			<Case condition={"plugin"}>
				<PluginIcon />
			</Case>
			<Case condition={"admin"}>
				<AdminIcon />
			</Case>
			<Case condition={"review"}>
				<ReviewSettingIcon/>
			</Case>
			<Case condition={"management"}>
				<ManagementIcon/>
			</Case>
		</If>
	);
};

const MainMenuItem = ({ active, disabled, title, engTitle, id, handleClick }) => {
	const { i18n } = useTranslation();
	const classString = `${active} ${disabled}`;
	return (
		<li className={classString}>
			<button onClick={handleClick}>
				<MainMenuIcon id={id} />
				{i18n.language === "ko" ? title : engTitle}
			</button>
		</li>
	);
};

const MainMenu = ({ list, selectedMenu, handleClick, currentType, user }) => {
	const mainMenuList = () => {
		return list.map((menu, i) => {
			if (menu === null) return null;
			const disabled = !menu.active && "disabled";
			const active = menu === selectedMenu && "active";
			const title = menu.title;
			const engTitle = menu.engTitle;
			const id = menu.id;
			return (
				<MainMenuItem
					key={i}
					handleClick={() => handleClick(id)}
					{...{ disabled, active, title, engTitle, id }}
				/>
			);
		});
	};

	return (
		<ul className="l__mainMenu">
			{currentType === "myPage" && (
				<li className="logo-wrap">
					<span className="logo">
						<img
							src={user.company.logo ? user.company.logo : SquareInitialImg}
							alt={user.company.name}
							onError={(e) => {
								e.target.src = SquareInitialImg;
							}}
						/>
					</span>
				</li>
			)}
			{mainMenuList()}
		</ul>
	);
};

export default MainMenu;
